<template>
  <div class="action-bar__mobile-row">
    <Button
      v-if="displayAddToCartButton"
      style-type="attraction"
      icon-type="icon-left"
      icon-name="add-shopping-cart"
      :icon-scale="1.4"
      size="medium"
      :active-state="isInitialLoading ? 'loading' : addToCartButtonState"
      :disabled="isInitialLoading || addToCartButtonDisabled"
      @click="$emit('add-to-cart', 'cart', amount)"
    >
      {{ addToCartMobile }}
    </Button>

    <Button
      style-type="link"
      size="small"
      :expand="true"
      icon-name="arrow-up-bold"
      icon-type="icon-left"
      @click="$emit('show-options')"
    >
      {{ $textDictionary['pdp.showOptions.label'] ?? 'pdp.showOptions.label' }}
    </Button>
  </div>
</template>

<script setup lang="ts">
import { Button } from '@hypercodestudio/basler-components';
import type { BtnStateType } from '@hypercodestudio/basler-components/dist/components/elements/Button.vue';
import { type CartType } from '~/stores/cartStore/model';

const { $textDictionary } = useNuxtApp();

interface Props {
  isInitialLoading: boolean;
  addToCartButtonState: BtnStateType;
  addToCartButtonDisabled: boolean;
  priceText: string;
  loggedIn: boolean;
  displayAddToCartButton: boolean;
  amount: number;
}

const props = defineProps<Props>();

const addToCartMobile = computed(() => {
  return (
    $textDictionary.value['pdp.addToCartMobile.label']?.replace(
      '{price}',
      String(props.priceText)
    ) ?? 'pdp.addToCartMobile.label'
  );
});

defineEmits<{
  'add-to-cart': [type: CartType, amount: number];
  'show-options': [];
}>();
</script>

<style scoped></style>
